import React from 'react';

export default function RegisterReview() {
  return <div>RegisterReview Page</div>;
}
